import {Button} from '@/components/ui/button/Button'
import {CheckIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {Access} from '../../types'
import {useAccountAccesses} from '../../queries/useAccountAccesses'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'

export const AccountAccessButton = ({
    accessesToAccount,
    onSuccess
}: {
    accessesToAccount: Access[]
    onSuccess?: () => void
}) => {
    const {t} = useTranslation()
    const queryClient = useQueryClient()
    const {mutate: accountAccesses, isPending} = useAccountAccesses({
        onSuccess: async () => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESSES]})
            onSuccess?.()
        }
    })

    if (accessesToAccount.length === 0 || !accessesToAccount.every(access => access.status === 'validated')) return null

    return (
        <Button
            variant="ghost"
            size="sm"
            disabled={isPending}
            onClick={() => accountAccesses({accessIds: accessesToAccount.map(access => access.id)})}
        >
            {isPending ? <Spinner /> : <CheckIcon />}
            {t('accesses:account_access', {count: accessesToAccount.length})}
        </Button>
    )
}
